<template>
    <div class="facturacion-section">
        <div class="facturacion-image">
            <img :src="a20" alt="Facturación automática">
        </div>
        <div class="facturacion-content">
            <h2 class="facturacion-title fuente-posm">
                Automatiza tu Facturación<br>y Conciliaciones.
            </h2>
            <p class="facturacion-text fuente-nova">
                Olvídate de solicitudes por WhatsApp o correos para facturar, Tus clientes emiten sus facturas por sí mismos desde un micrositio personalizado.
                <br><br>
                Tu equipo recibe reportes automáticos de conciliación, agilizando auditorías, devoluciones y finanzas.
            </p>
            <button class="button-outline hover-boton_mod fuente-nova2" @click="showModal">
                Descubre Como
            </button>
        </div>
    </div>
</template>

<script>
import { openContactModal } from '@/utils/modalHelper'

export default {
    name: 'FacturacionNew',
    data() {
        return {
            a20: require('@/assets/images/a20.webp')
        }
    },
    methods: {
        showModal() {
            openContactModal();
        }
    }
}
</script>

<style lang="css" scoped>
.facturacion-section {
    width: 100vw;
    height: 100vh;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    padding: 40px 60px;
    box-sizing: border-box;
    scroll-snap-align: start;
    gap: 40px;
}

.facturacion-image {
    flex: 0 0 auto;
    display: flex;
    justify-content: center;
    align-items: center;
    order: 1;
}

.facturacion-image img {
    width: 350px;
    height: auto;
}

.facturacion-content {
    flex: 1;
    max-width: 700px;
    order: 2;
}

.facturacion-title {
    color: var(--color-2);
    font-size: 65px;
    line-height: 1.1;
    margin: 0 0 20px 0;
}

.facturacion-text {
    color: var(--color-3);
    font-size: 29px;
    line-height: 1.3;
    margin: 0 0 30px 0;
    padding-left: 10px;
}

/* Tablet */
@media (max-width: 992px) and (min-width: 769px) {
    .facturacion-title {
        font-size: 60px;
    }

    .facturacion-text {
        font-size: 27px;
    }

    .facturacion-image img {
        width: 280px;
    }
}

/* Mobile */
@media (max-width: 768px) {
    .facturacion-section {
        flex-direction: column;
        justify-content: flex-start;
        height: 100vh;
        padding: 100px 20px 40px 20px;
        gap: 20px;
    }

    .facturacion-image {
        order: 2;
        width: 100%;
        flex: 1;
        display: flex;
        align-items: flex-start;
        justify-content: center;
        padding-top: 20px;
    }

    .facturacion-image img {
        width: 60%;
        max-width: 250px;
    }

    .facturacion-content {
        order: 1;
        max-width: 100%;
        flex: none;
    }

    .facturacion-title {
        font-size: 24px;
        line-height: 1.2;
        margin: 0 0 10px 0;
    }

    .facturacion-text {
        font-size: 16px;
        padding-left: 10px;
        margin: 0 0 20px 0;
    }
}
</style>
